import { TabsContentValues, tabsContentObj } from '@/interfaces/stories'
import { gql } from 'graphql-request'

import {
  EMBEDDED_ITEMS,
  IMAGE_FIELDS,
  META_INFORMATION,
  STORY_CARD_FIELDS,
  STORY_COLLECTION_FIELDS,
} from '../utils/fragments'

export const storiesOverviewQuery = (isRay: boolean = true) => {
  const id = isRay ? '3mvPBaI0KiVRd3tr2KkBWR' : '2SdpYzqpcL5eYLCQgimJqI'
  return gql`
    {
        storiesOverviewPage(id: "${id}") {
            metaInformation {
                ${META_INFORMATION}
            }
            title
            pinnedStoryAll {
                ${STORY_CARD_FIELDS}
            }
            pinnedStoryNews {
                ${STORY_CARD_FIELDS}
            }
            pinnedStoryBlog {
                ${STORY_CARD_FIELDS}
            }
            pinnedStoryPodcast {
                ${STORY_CARD_FIELDS}
            }
            pinnedStoryCase {
                ${STORY_CARD_FIELDS}
            }
            pinnedStoryTestimonial {
                ${STORY_CARD_FIELDS}
            }
            pinnedStoryWhitepaper {
                ${STORY_CARD_FIELDS}
            }
        }
    }
`
}

const storyCollectionRay = (
  storyTypeQuery: string | null,
  searchQuery: string,
  limit: number,
  skip: number
) => gql`
{
  storyCollection(where: {
      storyType: ${storyTypeQuery},
      displayOnRay: true
      OR: [{
            title_contains: "${searchQuery}",
          }, {
            description_contains: "${searchQuery}",
          }, {
            content_contains: "${searchQuery}",
          },
        ] }
    limit: ${limit},
    order: publicationDate_DESC
    skip: ${skip}) {
    ${STORY_COLLECTION_FIELDS}
  }
}`

const storyCollectionRvdb = (
  storyTypeQuery: string | null,
  searchQuery: string,
  limit: number,
  skip: number
) => gql`
{
  storyCollection(where: {
      storyType: ${storyTypeQuery},
      displayOnRvdb: true
      OR: [{
            title_contains: "${searchQuery}",
          }, {
            description_contains: "${searchQuery}",
          }, {
            content_contains: "${searchQuery}",
          },
        ] }
    limit: ${limit},
    order: publicationDate_DESC
    skip: ${skip}) {
    ${STORY_COLLECTION_FIELDS}
  }
}`

export const storyCollectionQuery = (
  storyType: TabsContentValues,
  searchQuery: string,
  skip: number,
  isRay: boolean
) => {
  const storyTypeQuery: TabsContentValues | null =
    storyType === tabsContentObj.ALL ? null : gql`"${storyType}"`
  const limit = 9

  return isRay
    ? storyCollectionRay(storyTypeQuery, searchQuery, limit, skip)
    : storyCollectionRvdb(storyTypeQuery, searchQuery, limit, skip)
}

export const storyCollectionSlugs = gql`
  {
    storyCollection {
      items {
        slug
      }
    }
  }
`

export const storyDetailPage = (slug: string) => gql`
  {
    storyCollection(where: {slug: "${slug}"}, limit: 1) {
      items {
        metaInformation {
            ${META_INFORMATION}
        }
        displayOnRay
        displayOnRvdb
        title
        image {
          ${IMAGE_FIELDS}
        }
        content {
          json
          ${EMBEDDED_ITEMS}
        }
        relevantStoriesCollection {
          items {
            title
            description
            slug
            publicationDate
            image {
              ${IMAGE_FIELDS}
            }
          }
        }
      }
    }
  }
`
